import api from './api' 

export const dropdownOptionsApi = {
  getStates() {
    return api.get('dropdown_options/states')
      .then(response => response.data)
  },
  getCountries() {
    return api.get('dropdown_options/countries')
      .then(response => response.data)
  },
  getDestinationCounselors(params = {includeInactive: false}) {
    return api.get('dropdown_options/destination_counselors', params)
      .then(response => response.data)
  },
  getDestinationGuides(params = {}) {
    return api.get('dropdown_options/destination_guides', params)
      .then(response => response.data)
  },
  getServices(params = {}) {
    return api.get('dropdown_options/services', params).then(r => r.data)
  },
  getServiceCancelTypes() {
    return api.get('dropdown_options/service_cancel_types')
      .then(response => response.data)
  },
  getCompanies() {
    return api.get('dropdown_options/companies').then(r => r.data)
  },
  getReloCompanies() {
    return api.get('dropdown_options/relo_companies').then(r => r.data)
  },
  getAreas() {
    return api.get('dropdown_options/areas').then(r => r.data)
  },
  getRoles() {
    return api.get('dropdown_options/roles').then(r => r.data)
  },
  getDgStatuses() {
    return api.get('dropdown_options/dg_statuses').then(r => r.data)
  },
  getRealtorAreas() {
    return api.get('dropdown_options/realtor_areas').then(r => r.data)
  },
  getRealtorStatuses() {
    return api.get('dropdown_options/realtor_statuses').then(r => r.data)
  },
};